import { getCookie } from "./getCookie";

const metrics = () => {
  /**
   * Установка метрик
   */
  function setFormatsGoals() {
    //Цель на появление модального окна "Задержитесь на минуту"
    document.addEventListener("mouseout", holdOnGoal, { once: true });

    function holdOnGoal() {
      setTimeout(() => {
        ym(74433037, "reachGoal", "popup_exit");
      }, 1500);
    }
  }

  /**
   * Метрики для сайтов ТСУ
   */
  function setTargets() {
    $(".page-header__phone").click(function () {
      if (window.yaCounter74433037) {
        yaCounter74433037.reachGoal("TopPhone");
      }
    });
    $(".page-header__btn").click(function () {
      if (window.yaCounter74433037) {
        yaCounter74433037.reachGoal("HeadButton");
      }
    });
    $(".home__btn").click(function () {
      if (window.yaCounter74433037) {
        yaCounter74433037.reachGoal("TopButton");
      }
    });

    setCategoriesMetrics();
  }

  /**
   * Метрики для блока категорий участников
   */
  function setCategoriesMetrics() {
    const categoriesModalIds = [1, 2, 3, 4, 5, 6].map(
      (n) => `categories-modal-${n}`
    );
    const categoriesBtns = categoriesModalIds.map(
      (modalId) => `[href="#${modalId}"]`
    );
    categoriesModalIds.forEach((modalId, index) => {
      const modalBtn = document.querySelector(`#${modalId} [href="#form"]`);
      if (!modalBtn) {
        return;
      }
      modalBtn.addEventListener("click", () => {
        const n = index + 1;
        const goalId = "CategoryModalButton" + n;
        if (window.yaCounter74433037) {
          yaCounter74433037.reachGoal(goalId);
        }
      });
    });
    categoriesBtns.forEach((selector, index) => {
      const btn = document.querySelector(selector);
      if (!btn) {
        return;
      }
      btn.addEventListener("click", () => {
        const n = index + 1;
        const goalId = "CategoryButton" + n;
        if (window.yaCounter74433037) {
          yaCounter74433037.reachGoal(goalId);
        }
      });
    });
  }

  // Инициализация
  setFormatsGoals();
  setTargets();
};

export const telegramButtonsMetrics = () => {
  /* Установка метрики по клику на кнопку телеграмма */
  (() => {
    const buttonsTelegram = document.querySelectorAll('.TelegramClickSZ');
    
    buttonsTelegram.forEach(button => {
      button.addEventListener('click', () => {
        ym(74433037,'reachGoal','TelegramClickSZ');
      })
    })
  })(); 

  /* Установка на бота _ym_uid из cookie */
  (() => {
    const buttonsBot = document.querySelectorAll('.TelegramBotClick');
    let cookie = getCookie("_ym_uid"),
    session = sessionStorage.getItem("ym_uid");

    if (buttonsBot.length > 0 && cookie || buttonsBot.length > 0 && session) {
      buttonsBot.forEach((button) => {
        if (cookie) {
          button.setAttribute('href', button.getAttribute('href') + "?_ym_uid=" + cookie);    
        } else if (session) {
          button.setAttribute('href', button.getAttribute('href') + "?_ym_uid=" + session);      
        }
      });
    }
  })();

  /* Цель на кнопку виджета Solo */
  (() => {
    try {
      const solo = document.querySelector('.solo_input');
      
      solo.addEventListener('click', () => {
        ym(74433037,'reachGoal','Solo');      
      })
    } catch(e) {
      console.log(e);      
    }
  })();
}

export default metrics;
